import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import { tagsApi } from '@/services/api';
import type { Tag, TagsState } from '@/types';

const initialState: TagsState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchTags = createAsyncThunk(
  'tags/fetchTags',
  async (search?: string) => {
    const response = await tagsApi.getTags(search);
    return response;
  }
);

const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTags.fulfilled, (state, action: PayloadAction<Tag[]>) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch tags';
      });
  },
});

export const { clearError } = tagsSlice.actions;
export default tagsSlice.reducer;
